import { useEffect, useRef } from 'react';
import { exclusiveAction } from '../lib/tool-exclusive';

/** A draw mode and a click tool (measure / annotate / nearest) are mutually exclusive; the newest wins. */
export function useToolDrawExclusive({ tool, setTool, activeDrawMode, setDrawMode }) {
  const prev = useRef({ tool, drawMode: activeDrawMode });
  useEffect(() => {
    const action = exclusiveAction(prev.current, { tool, drawMode: activeDrawMode });
    prev.current = { tool, drawMode: activeDrawMode };
    if (action === 'exitDraw') setDrawMode(null);
    else if (action === 'clearTool') setTool('select');
  }, [tool, activeDrawMode, setTool, setDrawMode]);
}
